import React, { Component } from "react";
import { EChartsOption } from "echarts";

import { AnalyticsChartType } from "@formant/core/model/AnalyticsChartType";

import { fromUtc } from "../../utils/fromUtc";
import { BaseChart } from "./BaseChart";
import {
    basicConfig,
    basicSeriesConfig,
    getAreaStyle,
    getItemStyle,
    legendConfig,
    tooltipConfig,
    xAxisConfig,
    yAxisConfig,
} from "./ChartConfig";

export interface ISeries {
    label: string;
    stackGroup?: string;
    originId?: string;
    values: number[];
}

export interface IChartProps {
    chartType?: AnalyticsChartType;
    series: ISeries[];
    catagoryAxis: string[];
    start?: string;
    end?: string;
    xAxisType: "category";
    xAxisLabel?: string;
}

export class Chart extends Component<IChartProps> {
    public render() {
        const { props } = this;
        const {
            chartType,
            catagoryAxis,
            xAxisLabel,
            start,
            end,
            series,
            xAxisType,
        } = props;

        if (!series || series?.length === 0) {
            return false;
        }

        const labels = series.map(_ => _.label);

        const ySeries = series.map((item, i) => ({
            ...basicSeriesConfig,
            name: item.label,
            id: item.label + i,
            dataGroupId: item.label + i,
            type: chartType || "line",
            // if there is only one xAxis value
            // then show the symbol instead of an emtpy chart
            showSymbol: chartType === "line" && catagoryAxis.length === 1,
            stack: item.stackGroup && chartType === "line",
            itemStyle: getItemStyle(chartType || "line", i),
            areaStyle: getAreaStyle(i),
            universalTransition: {
                enabled: true,
                seriesKeys: labels,
            },
            data: item.values,
        }));

        const legend = ySeries.map(_ => _.name);

        const option = {
            ...basicConfig,
            legend: {
                ...legendConfig,
                type: legend.length > 3 ? "scroll" : "plain",
                data: legend,
            },
            tooltip: tooltipConfig,
            xAxis: [
                {
                    ...xAxisConfig,
                    data: catagoryAxis,
                    type: xAxisType,
                    name: (xAxisLabel || "Time").toUpperCase(),
                    ...(start && end
                        ? {
                              min: fromUtc(new Date(start)).toISOString(),
                              max: fromUtc(new Date(end)).toISOString(),
                              boundaryGap: ["10%", "10%"],
                          }
                        : {
                              boundaryGap: true,
                              min: "dataMin",
                              max: "dataMax",
                          }),
                },
            ],
            yAxis: ySeries.map(_ => yAxisConfig),
            series: ySeries,
        } as EChartsOption;

        return <BaseChart option={option} />;
    }
}
